import { memo } from "react";
import { Button, Layout } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { AuraLayout } from "../components/AuraLayout";
import { FlowHeroMark } from "../components/FlowHeroMark";
import { RouteUnavailableInfo } from "../components/RouteUnavailableInfo";
import { ErrorAlertIcon as ErrorIcon } from "../assets/icons";
import { useStore } from "../store/globalState";
import { ScrollFadeIndicator } from "../components/ScrollFadeIndicator";

export interface RouteUnavailablePageProps {
  destinationCountry: string;
  payerCode?: string;
  onClose: () => void;
}

export const RouteUnavailablePage = memo(
  ({ destinationCountry, payerCode, onClose }: RouteUnavailablePageProps) => {
    const { t } = useTranslation();
    const { theme } = useStore();
    const colorConfig = theme.errorView;
    const { backgroundBtn, textColorBtn, iconColors, backgroundIcon } =
      colorConfig;

    return (
      <AuraLayout colorConfig={colorConfig} className="route-unavailable-page flow-landing-page">
        <Layout.Content className="landing-section flow-hero-section">
          <ScrollFadeIndicator color={colorConfig.bodyCopy} />
          <section className="flow-hero">
            <FlowHeroMark backgroundIcon={backgroundIcon}>
              <ErrorIcon size={60} colors={iconColors} />
            </FlowHeroMark>
            <RouteUnavailableInfo
              destinationCountry={destinationCountry}
              payerCode={payerCode}
            />
          </section>
        </Layout.Content>
        <Layout.Footer>
          <section className="footer-section">
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={onClose}
            >
              {t("routeUnavailable.back")}
            </Button>
          </section>
        </Layout.Footer>
      </AuraLayout>
    );
  }
);
